export default "__VITE_ASSET__DEAnKkPZ__"